// extracted by mini-css-extract-plugin
export default {"aside":"Aside_aside__sb5lW","scrollbar_hidden":"Aside_scrollbar_hidden__gmjrf","aside_content":"Aside_aside_content__nu-iM","active_link":"Aside_active_link__at4fz"};